// extracted by mini-css-extract-plugin
module.exports = {"itemSkeleton":"_b1479e3","headerSkeleton":"_2d6b213"};